import React from 'react';
import ContentLink from '../utils/ContentLink';

export default function EmailLink() {
  return <ContentLink href={"mailto:" + process.env.REACT_APP_CONTACT_EMAIL} anchor={process.env.REACT_APP_CONTACT_EMAIL} external={true} />
}